__turbopack_context__.v({
  "listing": "ListingLayout-module-scss-module__Y0G8cq__listing",
  "listing__rail": "ListingLayout-module-scss-module__Y0G8cq__listing__rail",
  "listing__results": "ListingLayout-module-scss-module__Y0G8cq__listing__results",
  "listing__skip": "ListingLayout-module-scss-module__Y0G8cq__listing__skip",
});
